module.exports = {
  title: 'MG Thailand',
  baseUrl: 'https://sns-ttpp.mgthai.com',
  // 测试项目地址
  baseApi: 'https://sns-ttpp.mgthai.com',
  // 测试api请求地址
  APPID: 'xxx',
  APPSECRET: 'xxx',
  $cdn: 'https://www.sunniejs.cn/static'
};